import {Component} from "preact";
import styles from './styles.scss';
import {TranslateService} from "../../../../services/TranslateService";
import ModuleLogoLinkProvider from "../../../../services/ModuleLogoLinkProvider";
import ConfigService from "../../../../services/ConfigService";

export default class AppListItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            error: false
        };
    }


    static defaultProps = {
        app: {}
    };

    render(props, state, context) {
        const app = this.props.app;
        const name = TranslateService.translatable(app.denomination);
        const description = TranslateService.translatable(app.description);
        const link = app.urls.backend;
        const navigate = (event) => {
            event.preventDefault();
            event.stopPropagation();
            ConfigService.navigateFunction(link);
        };

        const image = () => {
            return (this.state.error) ?
                (<div class={styles.appCardImageError} />) :
                (<img src={ModuleLogoLinkProvider.transform(app.key, 'svg', [], 'module-pictogram-color')} alt={name} onError={this.onImageError}/>);
        };

        return link ? (
            <a href={link} class={styles.appCard} onClick={navigate}>
                <div class={styles.appCardImage}>
                    {image()}
                </div>
                <div class={styles.body}>
                    <div class={styles.name}>{name}</div>
                    <div class={styles.description}>{description}</div>
                </div>
            </a>
        ) : (
            <a className={styles.appCard}>
                <div className={styles.appCardImage}>
                    {image()}
                </div>
                <div className={styles.body}>
                    <div className={styles.name}>{name}</div>
                    <div className={styles.description}>{description}</div>
                </div>
            </a>
        );
    }

    onImageError = () => {
        this.setState({
            error: true
        })
    };
}




// WEBPACK FOOTER //
// ./components/sections/apps/app-list-item/index.js